export default "__VITE_ASSET__B_kz3IW4__"